module.exports = __webpack_public_path__ + "media/img/Landing_Page/logos/4-9bede2ded3733e14042dc8ac0afb1abd.jpg";